import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Svg from 'svg-inline-react';
import WarningRedSvg from '@src/svgs/warning-red.svg';
import './styles.scss';

export default function FormValidationError({ className, message }) {
  return (
    <div className={classnames('form-validation-error', className)}>
      <Svg src={WarningRedSvg} />
      {message || 'Please fill all the required fields!'}
    </div>
  );
}

FormValidationError.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
};
